import SidebarComponent from './container/sidebarComponent'

export { default as SidebarLayout } from './components/sidebarLayout'


export default SidebarComponent
